export default "__VITE_ASSET__Dqn6yY5O__"